import { render, staticRenderFns } from "./NewsEdit.vue?vue&type=template&id=6b2cac2e&scoped=true&"
import script from "./NewsEdit.vue?vue&type=script&lang=js&"
export * from "./NewsEdit.vue?vue&type=script&lang=js&"
import style0 from "./NewsEdit.vue?vue&type=style&index=0&id=6b2cac2e&scoped=true&lang=css&"
import style1 from "./NewsEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2cac2e",
  null
  
)

export default component.exports